export enum ActionStatus {
  AWAITING_APPROVALS = "AWAITING_APPROVALS",
  REJECTED = "REJECTED",
  FAILED = "FAILED",
  PROCESSING_IN_PROGRESS = "PROCESSING_IN_PROGRESS",
  CONFIRMED = "CONFIRMED",
}
